import { getArticles, deleteArticle } from '../../../api/article'
import * as types from './mutation-types'
import { MINIMUM_CHARS_SEARCH } from '../../../config'

const initialState = {
    selected: {},
    searchString: '',
    page: 1,
    pages: 0,
    loading: false,
    list: [],
    filterInstanceId: null // TODO in case of multiple filters
}

const state = { ...initialState }
const mutations = {
    [types.SET_FILTERED_ARTICLES](state, articlesObj) {
        const { list, pages } = articlesObj
        state.list = list
        state.pages = pages
    },
    [types.ADD_SELECTED_FILTERED_ARTICLE]({ selected }, article) {
        const codeArticle = article.codeArticle
        const codeDeclinaison = article.codeDeclinaison
        const property = codeDeclinaison.length === 0
            ? codeArticle
            : `${codeArticle}.${codeDeclinaison}`
        Vue.set(
            selected,
            property,
            article
        )
    },
    [types.REMOVE_SELECTED_FILTERED_ARTICLE]({ selected }, article) {
        const { codeArticle, codeDeclinaison } = article
        let targetedProperty = codeArticle
        if (codeDeclinaison.length !== 0) {
            targetedProperty = `${codeArticle}.${codeDeclinaison}`
        }

        const deleted = deleteArticle(codeArticle)
        if (deleted) {
            Vue.delete(
                selected,
                targetedProperty
            )
        }
    },
    [types.SET_SELECTED_FILTERED_ARTICLES](state, articles) {
        state.selected = articles
    },
    [types.RESET_FILTERED_ARTICLES](state) {
        Object.entries(initialState).forEach(([key, value]) => {
            state[key] = value
        })
    },
    [types.SET_FILTERED_ARTICLES_SEARCH_STRING](state, searchString) {
        state.searchString = searchString
    },
    [types.SET_FILTERED_ARTICLES_PAGE](state, page) {
        state.page = page
    },
    [types.SET_LOADING_FILTERED_ARTICLES](state, loading) {
        state.loading = loading
    }
}
const actions = {
    async getFilteredArticles({ rootState, state, commit, dispatch }, setLoading = false) {
        const codeFamille = rootState.planVente.selected
        const { searchString } = state
        if (searchString.length === 0 && codeFamille === null) {
            dispatch('setLoadingFilteredArticles', false)
            dispatch('resetFilteredArticles')
            return
        }
        if (setLoading) dispatch('setLoadingFilteredArticles', true)

        const articlesObj = await getArticles({
            queryString: searchString,
            codeFamille: rootState.planVente.selected,
            selectedItems: [], // Not necessary.
            page: state.page,
            filterArticlesFields: true,
            excludeUnavailableArticles: false
        })
        dispatch('setLoadingFilteredArticles', false)
        commit(types.SET_FILTERED_ARTICLES, articlesObj)
    },
    setSelectedFilteredArticles({ commit }, articles) {
        commit(types.SET_SELECTED_FILTERED_ARTICLES, articles)
    },
    selectFilteredArticle({ state, commit }, article) {
        const { codeArticle, codeDeclinaison } = article
        const addArticle = () => {
            commit(types.ADD_SELECTED_FILTERED_ARTICLE, article)
        }
        const isDeclinaison = codeDeclinaison.length !== 0
        if (state.selected[codeArticle] === undefined && !isDeclinaison) {
            addArticle()
            return
        }
        if (state.selected[`${codeArticle}.${codeDeclinaison}`] === undefined
            && isDeclinaison) {
            addArticle()
            return
        }
        commit(types.REMOVE_SELECTED_FILTERED_ARTICLE, article)
    },
    resetFilteredArticles({ commit }) {
        commit(types.RESET_FILTERED_ARTICLES)
    },
    setFilteredArticlesSearchString({ commit, dispatch }, searchString) {
        dispatch('resetPageFilteredArticles')
        commit(types.SET_FILTERED_ARTICLES_SEARCH_STRING, searchString)
    },
    setLoadingFilteredArticles({ commit }, loading) {
        commit(types.SET_LOADING_FILTERED_ARTICLES, loading)
    },
    setPageFilteredArticles({ commit, dispatch }, page) {
        dispatch('setLoadingFilteredArticles', true)
        commit(types.SET_FILTERED_ARTICLES_PAGE, page)
        dispatch('getFilteredArticles')
    },
    resetPageFilteredArticles({ commit }) {
        commit(types.SET_FILTERED_ARTICLES_PAGE, 1)
    }
}

const getters = {
    filteredArticles: state => state.list,
    selectedFilteredArticles: state => state.selected,
    searchingFilteredArticles: state => state.loading,
    filteredArticlesPage: state => state.page,
    filteredArticlesPages: state => state.pages
}

export default { state, mutations, actions, getters }
